import PropTypes from 'prop-types'

const AddressCell = ({ row }) => {
  return (
    <div className="ctp-maintenance-requests-list__client-info-wrapper">
      <span>
        {row.original.buildingId.name}
        {row.original.clientId && row.original.clientId.yardiPropertyId
          ? ` (${row.original.clientId.yardiPropertyId})`
          : ''}
      </span>
      <span className="ctp-maintenance-requests-list__address-info">
        {row.original.clientId
          ? `#${row.original.clientId.apartment}, ${row.original.clientId.street}`
          : `${row.original.buildingId.address}`}
      </span>
    </div>
  )
}

AddressCell.propTypes = {
  row: PropTypes.object,
}

export default AddressCell
